export default "__VITE_ASSET__DqFUTvbw__"